import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
// import { Footer, Navbar } from "../../components";
import { Navbar, Footer } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears, renderStars } from "../Utils";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../../css/SliderStyles.css";// Custom styles
// import "../../css/Tabs.css";
// import "../../assets/css/bootstrap.min.css";
// import "../../assets/css/fontawesome-all.min.css";
// import "../../assets/css/slick.css";
// import "../../assets/css/line-awesome.min.css";
// import "../../assets/css/main.css";
// import "../../assets/css/responsive.css";
import "../../assets/css/fontawesome-all.min.css";
// import "../../src/assets/css/slick.css";
// import "../../src/assets/css/line-awesome.min.css";
// import "../../src/assets/css/main.css";

import "../../assets/stylesheet/bootstrap.min.css";
import "../../assets/stylesheet/all-fontawesome.min.css";
import "../../assets/stylesheet/animate.min.css";
import "../../assets/stylesheet/magnific-popup.min.css";
import "../../assets/stylesheet/owl.carousel.min.css";
import "../../assets/stylesheet/style.css";
import SearchIcon from "../../assets/images/all/search.svg";

import StarIcon from "../../assets/images/all/star-svgrepo-com.svg";
import LectureImage from "../../assets/images/all/leachure.png";
import { debounce } from 'lodash'; // Optional for debouncing
import shapeImage from "../../assets/images/all/shape_1.png";
import shapeImage1 from "../../assets/images/icons/Unions.svg";
import shapeImage2 from "../../assets/images/icons/Union-2.svg";
import SliderImagess from "../../assets/images/course/image-1.png";
import SliderImagess2 from "../../assets/images/course/image-2.png";
import backgroundBanner1 from "../../assets/img/logo/element1.png";
import instituteBanner from "../../assets/img/institute/banner-bg.jpg";
import menuShape from "../../assets/img/logo/menu-shape.png";
import thumb1 from "../../assets/img/logo/thumb1.png";
import curveBg from "../../assets/img/logo/curve.png";
import addGirl from "../../assets/img/add/add-girl.png";
import addBanner from "../../assets/img/add/add-banner.jpg";
import VideoSlider from "../../components/VideoSlider";
import BranchSlider from "../../components/BranchSlider";
import TopperSlider from "../../components/TopperSlider";
import SterLingResultSlider from '../../components/SterLingResultSlider'
import { Modal, Button, Form } from "react-bootstrap";
import ExpertSlider from '../../components/ExpertSlider';
import CenterList from '../../components/CenterList';

// {profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null}

const CustomArrow = ({ className, style, onClick, isLeft }) => {
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                color: 'black',
                borderRadius: '50%',
                position: 'absolute',
                top: '50%', // Center vertically
                transform: 'translateY(-50%)', // Adjust for arrow size
                [isLeft ? 'left' : 'right']: '10px', // Adjust horizontal position
                zIndex: 2, // Ensure it's above the image
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            onClick={onClick}
        >
            {isLeft ? '<' : '>'}
        </div>
    );
};

const TeacherDetail = (props) => {
    const [userId, setUserId] = useState(null);
    const { id } = useParams();
    const [ids, setIds] = useState(id);
    console.log(ids);
    const [mainSlider, setMainSlider] = useState(null);
    const [thumbSlider, setThumbSlider] = useState(null);
    const [categories, setCategories] = useState([]);
    const [boards, setBoards] = useState([]);
    const [standards, setStandards] = useState([]);
    const [cities, setCities] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedBoard, setSelectedBoard] = useState('');
    const [selectedStandard, setSelectedStandard] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [results, setResults] = useState([]);
    const [letsParadigm,setLetsParadign] = useState([])

    const [finderList, setFinderList] = useState([]);
    const [activeTab, setActiveTab] = useState("All");
    const [mediaimg, setMediaimg] = useState("");
    const [mediapdf, setMediapdf] = useState("");
    const [profileimg, setProfileimg] = useState(""); // State to hold roles data
    const [bioInfo, setBioInfo] = useState({
        bio_info: "",
    });
    const [profileData, setProfileData] = useState({
        id: "",
        full_name: "",
        email_id: "",
        username: "",
        location: "",
        phone_no: ""
    });

    const [otherInfoDetails, setOtherInfoDetails] = useState({
        no_of_students_studyind: "",
        year_of_establishment: "",
        timings: "",
        hostels: "",
        approved_by: "",
        affiliation: "",
        gender_composition: "",
    });

    const [streamDetails1, setStreamDetails1] = useState([]);
    const [facilitydata, setFacilityData] = useState([])
    const [instituteFollower, setInstituteFollower] = useState([]);
    const [rating, setRating] = useState(0);
    const [instituteId, setinstituteId] = useState([]);
    const [averageRatings, setAverageRatings] = useState([]);
    const [posts, setPosts] = useState([]);
    const [doubtData, setDoubtData] = useState({
        name: "",
        email: "",
        phone: "",
        category: "",
        board: "",
        standards: "",
    });
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });
    const [formData3, setFormData3] = useState({
        phone: "",

    });
    const [showFormModal, setShowFormModal] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showFormModal1, setShowFormModal1] = useState(false);
    const [showOtpModal1, setShowOtpModal1] = useState(false);
    const [formData1, setFormData1] = useState({ name: "", email: "", phone: "" });
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [otp1, setOtp1] = useState(["", "", "", "", "", ""]);
    const [successMessage, setSuccessMessage] = useState(""); // State for success message
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
    const [followedBasedOnUserId, setFollowedBasedOnUserId] = useState([]);
    const [followingStatus, setFollowingStatus] = useState({});
    const [teacherFollower, setTeacherFollower] = useState([]);
    const tabs = ["All", "Management", "Technology", "Design"];
    const location = useLocation();
    const { message } = location.state || {};

    const encodedUserId = encodeURIComponent(ids);
    const profileUrl = `${window.location.origin}/InstituteDetail/${encodedUserId}`;

    const urlToShare = profileUrl; // URL to be shared
    const shareLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        urlToShare
    )}`;
    console.log("message //////", message)
    const sliderImages = [
        { src: SliderImagess, alt: "Woxsen University 1" },
        { src: SliderImagess2, alt: "Woxsen University 2" },
        { src: SliderImagess, alt: "Woxsen University 3" },
        { src: SliderImagess2, alt: "Woxsen University 4" },
        { src: SliderImagess, alt: "Woxsen University 5" },
    ];

    useEffect(() => {
        const fetchInstituteFollowers = async () => {
            try {
                // Create an array of promises for each product API call
                const response = await axios.get(`${API_BASE_URL}/getInstitutefollowers?institute_id=${profileData.id}`);
                console.log("Full Response: ", response.data);
                setTeacherFollower(response.data);
            } catch (err) {
                // Handle errors
                //setError(err.message);
            } finally {
                //setLoading(false);
            }
        };

        fetchInstituteFollowers();
    }, [profileData]); // Run the effect when cartItems changes

    // Follow and unfollow start
    useEffect(() => {
        fetchFollowBasedOnUserId();
    }, [profileData]); // Fetch when profileData changes

    const fetchFollowBasedOnUserId = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/followers?user_id=${ACCESS_Log_In_User_Id()}`
            );
            setFollowedBasedOnUserId(response.data);
        } catch (err) {
            console.error("API Error: ", err);
        }
    };

    const toggleFollow = async (id) => {
        const newFollowStatus = !followingStatus[id];
        setFollowingStatus((prevState) => ({
            ...prevState,
            [id]: newFollowStatus,
        }));
        const apiUrl = newFollowStatus ? `${API_BASE_URL}/follow` : `${API_BASE_URL}/unfollow`;
        try {
            const response = await axios.post(apiUrl, {
                user_id: ACCESS_Log_In_User_Id(),
                institute_id: id,
            });
            fetchFollowBasedOnUserId(); // Optionally re-fetch data
        } catch (error) {
            console.error(error);
            setFollowingStatus((prevState) => ({
                ...prevState,
                [id]: !newFollowStatus,
            }));
        }
    };

    // Follow and unfollow end

    const handleChange1 = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange2 = (e) => {
        setFormData3({ ...formData3, [e.target.name]: e.target.value });
    };

    const updateDoubtData = (e) => {
        setDoubtData({ ...doubtData, [e.target.name]: e.target.value });
    };


    const submitDoubtForm = async (e) => {
        e.preventDefault();

        // Validation
        if (!doubtData.name || !doubtData.email || !doubtData.phone || !doubtData.category || !doubtData.board || !doubtData.standards) {
            alert("All fields are required!");
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/savehaveDoubtData`, null, {
                params: {
                    name: doubtData.name,
                    email: doubtData.email,
                    phone: doubtData.phone,
                    category: doubtData.category,
                    board: doubtData.board,
                    standards: doubtData.standards,
                },
            });
            console.log("success ful dout", response)
            if (response.data.code == 200) {
                alert(response.data.message);
                setDoubtData({ name: "", email: "", phone: "", category: "", board: "", standards: "" }); // Reset form
            } else {
                alert("Submission failed. Please try again.");
            }
        } catch (error) {
            console.error("API Call Failed:", error);
            alert("Failed to submit. Please try again later.");
        }
    };

    // Handle OTP Input Change
    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return; // Only allow numbers
        let newOtp = [...otp];
        newOtp[index] = value.slice(0, 1); // Restrict to 1 digit
        setOtp(newOtp);

        // Move to next input field automatically
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleOtpChange1 = (index, value) => {
        if (!/^\d*$/.test(value)) return; // Only allow numbers
        let newOtp = [...otp1];
        newOtp[index] = value.slice(0, 1); // Restrict to 1 digit
        setOtp1(newOtp);

        // Move to next input field automatically
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    // Handle Form Submission
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Validation check
        if (!formData.name || !formData.email || !formData.phone) {
            alert("All fields are required!");
            return;
        }

        try {
            // Hide form modal and show OTP modal
            setShowFormModal(false);
            setShowOtpModal(true);

            // Call API to send OTP
            const response = await axios.post(`${API_BASE_URL}/sendMobileVerificationDownloadBrochureRequest`, {
                mobile_no: formData.phone,
            });
            console.log("api response send otp", response)
            if (response.data.status == 'success') {
                alert("OTP sent successfully!");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            //   alert("Failed to send OTP. Please try again.");
        }
    };

    const handleFormSubmit1 = async (e) => {
        e.preventDefault();

        // Validation check
        if (!formData3.phone) {
            alert("Mobile no required!");
            return;
        }

        try {
            // Hide form modal and show OTP modal
            setShowFormModal1(false);
            setShowOtpModal1(true);

            // Call API to send OTP
            const response = await axios.post(`${API_BASE_URL}/sendMobileVerificationDownloadBrochureRequest`, {
                mobile_no: formData3.phone,
            });
            console.log("api response send otp", response)
            if (response.data.status == 'success') {
                alert("OTP sent successfully!");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            //   alert("Failed to send OTP. Please try again.");
        }
    };



    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        const finalOtp = otp.join("");

        if (finalOtp.length !== 6) {
            alert("Please enter a valid 6-digit OTP.");
            return;
        }

        try {
            const formdata = new FormData();
            formdata.append("name", formData.name);
            formdata.append("email", formData.email);
            formdata.append("mobile_no", formData.phone);
            formdata.append("code", finalOtp);

            const response = await axios.post(`${API_BASE_URL}/verifyPhoneDownloadBrochure`, formdata, {
                headers: { "Content-Type": "multipart/form-data" }, // Ensure proper headers for FormData
            });
            console.log("api response verify send otp", response)
            if (response.data.status == 'success') {
                alert("OTP verified!");
                fetchMedia1()
                // window.location.href = "/brochure.pdf"; // Update with actual file path
                setShowOtpModal(false);
            } else {
                alert("Invalid OTP, please try again.");
            }
        } catch (error) {
            console.error("OTP verification failed", error);
            //   alert("OTP verification failed.");
        }
    };

    const handleOtpSubmit1 = async (e) => {
        e.preventDefault();
        const finalOtp = otp1.join("");

        if (finalOtp.length !== 6) {
            alert("Please enter a valid 6-digit OTP.");
            return;
        }

        try {
            const formdata = new FormData();
            formdata.append("name", "null");
            formdata.append("email", "null");
            formdata.append("mobile_no", formData3.phone);
            formdata.append("code", finalOtp);

            const response = await axios.post(`${API_BASE_URL}/verifyPhoneDownloadBrochure`, formdata, {
                headers: { "Content-Type": "multipart/form-data" }, // Ensure proper headers for FormData
            });
            console.log("api response verify send otp", response)
            if (response.data.status == 'success') {
                alert(`OTP verified! institute number is this ${profileData?.phone_no}`);

                // window.location.href = "/brochure.pdf"; // Update with actual file path
                setShowOtpModal1(false);
            } else {
                alert("Invalid OTP, please try again.");
            }
        } catch (error) {
            console.error("OTP verification failed", error);
            //   alert("OTP verification failed.");
        }
    };


    // Handle input change

    // Handle input change
    const handlesubsChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        // alert("nddnmdn")
        // return false
        e.preventDefault(); // Prevent page reload
        setSuccessMessage(""); // Reset messages
        setErrorMessage("");

        try {
            const response = await axios.post(`${API_BASE_URL}/saveEnquiryData`, formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 201) {
                setSuccessMessage("Enquiry submitted successfully!");
                setFormData({ name: "", email: "" }); // Reset form
            } else {
                setErrorMessage("Failed to submit enquiry. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setErrorMessage("Failed to submit enquiry. Please try again.");
        }
    };



    // Main slider settings
    const mainSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: thumbSlider,
        prevArrow: <CustomArrow isLeft={true} />,
        nextArrow: <CustomArrow isLeft={false} />,
    };



    const thumbnailSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true, // Enable click to select thumbnail
        asNavFor: mainSlider, // Synchronize with main slider
        arrows: false, // Hide arrows for thumbnail slider
    };

    useEffect(() => {
        fetchProfile();
        fetchMedia();
        fetchCategories();
        fetchBoards()
        fetchCities()
        fetchStandards()
        fetchAreas()
        fetchParadiagm()
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
        fetchFacilityDetails();
        // fetchLagacyDetails()
        // fetchExpertDetails()
        // GetinstituteManagerPersonalInfo()
        const user = ACCESS_Log_In_User_Id();
        setUserId(user);
    }, []);

    const fetchProfile = async () => {
        // alert(ids)
        axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${ids}`)
            .then(function (response) {
                // console.log(response.data.code);
                if (response.data.code == 200) {
                    console.log("4454444544545======", response.data.data[0]);
                    setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
    };


    const fetchStandards = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterStandardsBasedOnUserId?user_id=${ids}`);
            console.log("standatrd ", response.data.data)
            const data = response.data.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setStandards(data);
        } catch (error) {
            console.error('Error fetching standards:', error);
        }
    };

    const fetchCities = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterCityBasedOnUserId?user_id=${ids}`);
            const data = response.data.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setCities(data);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    const fetchAreas = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterAreaBasedOnUserId?user_id=${ids}`);
            const data = response.data.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setAreas(data);
        } catch (error) {
            console.error('Error fetching areas:', error);
        }
    };



    const fetchBoards = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterBoardBasedOnUserId?user_id=${ids}`);
            const data = response.data.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setBoards(data);
        } catch (error) {
            console.error('Error fetching boards:', error);
        }
    };

    const fetchCategories = async () => {
        // const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getFindTheCenterCategoryBasedOnUserId?user_id=${ids}`)
            .then(function (response) {
                console.log("getFindTheCenterCategory ssss", response.data);
                const data = response.data.data?.map(item => ({
                    ...item,
                    isEditing: false,
                })) || [];
                setCategories(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    const fetchParadiagm = async () => {
        // alert(ids)
        axios.get(`${API_BASE_URL}/getLetsEvolveTheParadigmsByUserId?user_id=${ids}`)
            .then(function (response) {
                // console.log(response.data.code);
                console.log("44544445445451234======", response.data);
                if (response.data.code == 200) {
                    console.log("44544445445451234======", response.data);
                    setLetsParadign(response.data);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
    };
    const fetchLagacyDetails = async () => {

        axios.get(`${API_BASE_URL}/getSterlingResultsMediaFile?user_id=${ids}`)
            .then(function (response) {
                console.log("agacydata======", response);
                if (response.data.code == 200) {
                    console.log("lagacydata======", response.data.data[0]);
                    // setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
    };

    const fetchExpertDetails = async () => {

        axios.get(`${API_BASE_URL}/getMeetOurExpertTeamMediaFile?user_id=${ids}`)
            .then(function (response) {
                console.log("agacydata======", response);
                if (response.data.code == 200) {
                    console.log("lagacydata======", response.data.data[0]);
                    // setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log("1111121212122112", error);
            });
    };

    const fetchMedia = async () => {
        axios.get(`${API_BASE_URL}/getinstituteMediaDetails?user_id=${ids}`)
            .then(function (response) {
                console.log("Institute media", response);
                if (response.data.code == 200) {
                    setMediaimg(response.data.data);
                }
            })
            .catch(function (error) {
            });
    };



    const fetchBioInfoDetails = async () => {

        axios.get(`${API_BASE_URL}/getbioInfoDetails?user_id=${ids}`)
            .then(function (response) {
                //console.log(response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setbioInfoDetails(response.data.data[0]);
                    setBioInfo({
                        id: response.data.data[0]["id"],
                        bio_info: response.data.data[0]['bio_info'],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchPersonalInfoDetails = async () => {

        axios.get(`${API_BASE_URL}/getpersonalInfoDetails?user_id=${ids}`)
            .then(function (response) {
                console.log(response);
                if (response.data.code == 200) {
                    console.log("===================", response.data.data[0]);
                    //setpersonalInfoDetails(response.data.data[0]);
                    setProfileData({
                        id: response.data.data[0]["id"],
                        full_name: response.data.data[0]["full_name"],
                        email_id: response.data.data[0]["email_id"],
                        username: response.data.data[0]["username"],
                        location: response.data.data[0]["location"],
                        phone_no: response.data.data[0]["phone_no"],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    useEffect(() => {
        const fetchInstituteFollowers = async () => {
            axios.get(`${API_BASE_URL}/getInstitutefollowers?institute_id=${profileData?.id}`)
                .then(function (response) {
                    if (response.status == 200) {
                        setInstituteFollower(response.data);
                    }
                })
                .catch(function (error) {
                    console.log("1111121212122112", error);
                });
        };

        fetchInstituteFollowers();
    }, [profileData]); // Run the effect when cartItems changes

    const fetchOtherInfoDetails = async () => {

        axios.get(`${API_BASE_URL}/getInstitutesOtherDataById/${ids}`)
            .then(function (response) {
                if (response.data.code == 200) {
                    setOtherInfoDetails({
                        id: response.data.data[0]["id"],
                        no_of_students_studyind: response.data.data[0]["no_of_students_studyind"],
                        year_of_establishment: response.data.data[0]["year_of_establishment"],
                        timings: response.data.data[0]["timings"],
                        hostels: response.data.data[0]["hostels"],
                        approved_by: response.data.data[0]["approved_by"],
                        affiliation: response.data.data[0]["affiliation"],
                        gender_composition: response.data.data[0]["gender_composition"],
                    });

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchMedia1 = async () => {
        // alert(ids)
        axios.get(`${API_BASE_URL}/getDownloadBrochureFileBasedOnUserId?user_id=${ids}`)
            .then(function (response) {
                console.log("fsdhfk kjsdhkjshd", response.data.data);
                if (response.data.code == 200) {
                    // setMediapdf(response.data.data);
                    downloadPDF(response.data.data[0].media_image_path)
                    // window.location.href = response.data.data[0].media_image_path
                }
            })
            .catch(function (error) {
            });
    };

    const downloadPDF = (filePath) => {
        if (!filePath) {
            alert("File not found!");
            return;
        }

        // Construct the complete file URL (modify API_BASE_URL accordingly)
        const fileUrl = `${Image_Base_Url}/${filePath}`;

        // Create a hidden <a> element to trigger the download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "brochure.pdf");

        // Append link to body, trigger click, then remove link
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleDownloadClick = async (e) => {
        e.preventDefault();

        if (ACCESS_TOKEN_NAME()) {
            // If token exists, allow download
            // window.location.href = "/brochure.pdf"; // Update with actual file path


            fetchMedia1()
        } else {
            // If no token, show OTP verification modal
            setShowFormModal(true);
        }
    };

    const fetchStreamDetails = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getInstitutesStreamById/${ids}`);

            if (response.data.code === 200) {
                // Directly use response data instead of mapping unnecessarily
                const data = response.data.data || []; // Default to an empty array if `data` is undefined
                setStreamDetails1(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:", error);
        }
    };
    const fetchFacilityDetails = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getInstitutesFacilitiesById/${ids}`);
            if (response.data.code === 200) {
                // Directly use response data instead of mapping unnecessarily
                const data = response.data.data || []; // Default to an empty array if `data` is undefined
                setFacilityData(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:", error);
        }
    }


    const GetinstituteManagerPersonalInfo = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getinstituteManagerPersonalInfo/${user_id}`);

            if (response.data.code === 200) {
                setManagers(response.data.data);
            } else {
                // console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:77777777777777777", error);
        }
    };
    const getPostDetails = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getPostDetails?user_id=${ids}`);
            console.log(response.data.code);
            // if (response.data.code === 200) {
            setPosts(response.data); // Set video data
            // } else {
            //     // setError("Failed to fetch video details.");
            // }
        } catch (err) {
            console.error(err);
            // setError("An error occurred while fetching data.");
        } finally {
            // setLoading(false); // Stop loading indicator
        }
    };
    // Rating start
    const fetchRatings = async () => {
        try {
            // Directly await the axios.get call since it's a single promise
            const response = await axios.get(`${API_BASE_URL}/ratings/institute/${profileData.id}`);
            // Assuming response.data.data is where the ratings are stored
            const courserating = response?.data?.data;
            const ratingsArray = courserating.map(item => item.rating);
            if (!Array.isArray(courserating)) {
                console.warn("Expected an array of ratings, but received:", courserating);
                return;
            }
            const averageRating = calculateAverageRating(ratingsArray);
            setAverageRatings(averageRating);
            renderStars(averageRating);

        } catch (err) {
            console.error("Error fetching ratings:", err);
        }
    };

    useEffect(() => {
        fetchRatings();
        getPostDetails();
    }, [profileData]);

    useEffect(() => {
        console.log("Updated bio_info:", bioInfo.bio_info, ACCESS_TOKEN_NAME());
    }, [bioInfo]);
    const calculateAverageRating = (ratings) => {
        if (ratings.length === 0) return "0.00";
        const totalRating = ratings.reduce((sum, rating) => sum + rating, 0);
        return (totalRating / ratings.length).toFixed(2); // Return average rounded to 2 decimal places
    };
    // Rating end
    const bannerPadhaiStyle1 = {
        backgroundImage: `url(${backgroundBanner1})`,
    };

    const instituteBannerStyle = {
        backgroundImage: mediaimg ? `url(${Image_Base_Url}${encodeURIComponent(mediaimg.media_image_path)})` : "none",
    };

    const curvebgStyle = {
        backgroundImage: `url(${curveBg})`,
    };


    const saveFinderData = async (e) => {
        e.preventDefault();
      
        const queryParams = new URLSearchParams({
          user_id: ids,
          category_name: selectedCategory || '',
          board_name: selectedBoard || '',
          standards_name: selectedStandard || '',
          city_name: selectedCity || '',
          area_name: selectedArea || '',
        });
      
        console.log("queryParams", queryParams.toString());
      
        try {
          const res = await axios.post(
            `${API_BASE_URL}/findTheCenterSearch?${queryParams.toString()}`,
            {}, // empty body since params are in query
            {
              headers: {
                // Optional headers can go here
              },
            }
          );
      
          console.log("data from the API:", res);
        //   alert(res);
          setResults(res.data);
        } catch (error) {
          console.error('Error saving finder data:', error);
          alert('Error saving data');
        }
      };
      
      

    // {profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null}
    console.log("render data will be ", letsParadigm)
    return (
        <>
            <Navbar />
            <main class="">
                <section class="banner_padhai">
                    <div class="banner_padhai1" style={bannerPadhaiStyle1}></div>
                    <div class="hero-section">
                        <div class="">
                            <div class="hero-single pd-banner banner_pd_bottom">
                                <div class="container">
                                    {/* <div class="text-center form-group srch_area mt-3 layer_up">
                                    <input type="search" name="search-field" placeholder="Find Institute, Colleges, Courses, Exams" required="" /><i class="far fa-search srch_glass"></i>
                                    <button type="submit">Search</button>
                                </div> */}
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="pd-dashboard-banner-bg mt-30" style={instituteBannerStyle}>
                                                {/* <div class="profile_img_chng">
                                                <a href="#" class="tp-btn-add-course"><i class="fa-light fa-camera"></i> </a>
                                            </div> */}
                                                <div class="pd-instructor-wrap d-flex justify-content-between ">
                                                    <div class="tp-instructor-info d-flex position-relative">
                                                        {/* <div class="pd-profile-pic-btn">
                                                        <a href="#" class="tp-btn-add-course"><i class="fa-regular fa-plus"></i> </a>
                                                    </div> */}
                                                        <div class="pd-instructor-avatar">
                                                            <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : null} alt="profile" />
                                                        </div>
                                                        <div class="pd-instructor-content">
                                                            <h4 class="pd-instructor-title">{profileData?.full_name}</h4>
                                                            <div class="pd-instructor-rate d-flex align-items-center">
                                                                <div class="pd-instructor-rating">
                                                                    {renderStars(averageRatings)}
                                                                </div>
                                                                <span>{String(averageRatings)}</span>
                                                                <span> Ratings </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="banner_padhai1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="pd_outerall">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-3">
                                <div class="pd-user-sidebar">
                                    <div class="pd-user-wrap">
                                        <div class="pd-user-menu">
                                            <nav>
                                                <ul>
                                                    <li class="pd-user-menu-section">
                                                        <p class="pd-user-menu-title">Welcome</p>
                                                        <ul>
                                                            <li>
                                                                <a href={`/InstituteDetail/${ids}`} class="active">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Dashboard
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href={`/InstituteAbout/${ids}`} class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> About Us
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href={`/InstitutePosts/${ids}`} class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Posts
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href={`/InstituteCourseList/${ids}`} class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Courses
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href={`/InstituteVideoList/${ids}`} class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Videos
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="#" class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Admission Form
                                                                </a>
                                                            </li>

                                                            {/* <li>
                                                                <a href="#" class="">
                                                                    <span>
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                                                            <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                                                            <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                                                            <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                                                                        </svg>
                                                                    </span> Reviews
                                                                </a>
                                                            </li> */}
                                                        </ul>
                                                    </li>
                                                    <li class="pd-user-menu-section">
                                                        <p class="pd-user-menu-title space-gap">User</p>
                                                        <ul>
                                                            {/* <li>
                                                            <a href="#" class="">
                                                                <span>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M7.60509 10.2644C6.32151 10.2644 5.2832 9.26439 5.2832 8.00839C5.2832 6.75239 6.32151 5.74438 7.60509 5.74438C8.88867 5.74438 9.90245 6.75239 9.90245 8.00839C9.90245 9.26439 8.88867 10.2644 7.60509 10.2644Z" fill="currentColor"></path>
                                                                        <path opacity="0.4" d="M14.9841 9.896C14.8288 9.656 14.608 9.416 14.3219 9.264C14.093 9.152 13.9458 8.968 13.815 8.752C13.398 8.064 13.6433 7.16 14.3382 6.752C15.1558 6.296 15.4174 5.28 14.9432 4.488L14.3955 3.544C13.9294 2.752 12.9075 2.472 12.0981 2.936C11.3786 3.32 10.4548 3.064 10.0378 2.384C9.90702 2.16 9.83344 1.92 9.84979 1.68C9.87432 1.368 9.77621 1.072 9.62905 0.832C9.32655 0.336 8.77878 0 8.17378 0H7.02101C6.42419 0.016 5.87642 0.336 5.57392 0.832C5.41858 1.072 5.32865 1.368 5.345 1.68C5.36135 1.92 5.28777 2.16 5.15696 2.384C4.74 3.064 3.81615 3.32 3.10487 2.936C2.28731 2.472 1.27352 2.752 0.799336 3.544L0.251567 4.488C-0.214445 5.28 0.0471757 6.296 0.856566 6.752C1.5515 7.16 1.79677 8.064 1.38798 8.752C1.249 8.968 1.10184 9.152 0.872917 9.264C0.594945 9.416 0.349675 9.656 0.218865 9.896C-0.0836348 10.392 -0.0672835 11.016 0.235216 11.536L0.799336 12.496C1.10184 13.008 1.66596 13.328 2.2546 13.328C2.53258 13.328 2.8596 13.248 3.12122 13.088C3.32561 12.952 3.57088 12.904 3.84068 12.904C4.65007 12.904 5.32865 13.568 5.345 14.36C5.345 15.28 6.09716 16 7.04554 16H8.15743C9.09763 16 9.84979 15.28 9.84979 14.36C9.87432 13.568 10.5529 12.904 11.3623 12.904C11.6239 12.904 11.8692 12.952 12.0817 13.088C12.3434 13.248 12.6622 13.328 12.9484 13.328C13.5288 13.328 14.093 13.008 14.3955 12.496L14.9678 11.536C15.2621 11 15.2866 10.392 14.9841 9.896Z" fill="currentColor"></path>
                                                                    </svg>
                                                                </span> Settings
                                                            </a>
                                                        </li> */}
                                                            {ACCESS_TOKEN_NAME() && (
                                                                <li>
                                                                    <a href="/logout" class="">
                                                                        <span>
                                                                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.4" d="M9.94863 0C10.3714 0 10.7222 0.341829 10.7222 0.773613V17.2264C10.7222 17.6492 10.3804 18 9.94863 18C4.65028 18 0.953125 14.3028 0.953125 9.0045C0.953125 3.70615 4.65927 0 9.94863 0Z" fill="currentColor"></path>
                                                                                <path d="M16.5143 8.58188L13.9596 6.01816C13.6987 5.75729 13.2669 5.75729 13.006 6.01816C12.7452 6.27903 12.7452 6.71082 13.006 6.97169L14.4093 8.37498H5.80064C5.43182 8.37498 5.12598 8.68083 5.12598 9.04965C5.12598 9.41846 5.43182 9.72431 5.80064 9.72431H14.4093L13.006 11.1276C12.7452 11.3885 12.7452 11.8203 13.006 12.0811C13.141 12.2161 13.3119 12.279 13.4828 12.279C13.6537 12.279 13.8246 12.2161 13.9596 12.0811L16.5143 9.51741C16.7752 9.26554 16.7752 8.84275 16.5143 8.58188Z" fill="currentColor"></path>
                                                                            </svg>
                                                                        </span> Logout
                                                                    </a>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div class="pd-user-banner d-flex align-items-center">
                                            <div class="pd-user-banner-text">
                                                <h4 class="pd-user-banner-title">Online Education</h4>
                                                <div class="pd-user-banner-btn">
                                                    <a href="#" class="theme-btn">View Course</a>
                                                </div>
                                            </div>
                                            <div class="tp-user-banner-shape"><img src={menuShape} alt="user-banner" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-9">
                                <div class="row banner_social">
                                    <div class="col-md-12">
                                        <div class="pd-user-banner-btn">
                                            <a href="#" class="theme-btn veryfied me-2" onClick={(e) => e.preventDefault()}>Verified <i class="fa-regular fa-check"></i></a>
                                            {/* <a href="#" class="theme-btn connect me-2" onClick={(e) => e.preventDefault()}> Connect Me <i class="fa-light fa-handshake"></i></a> */}
                                            {/* <a href="#" class="theme-btn share" onClick={(e) => e.preventDefault()}> Share <i class="fa-regular fa-share-nodes"></i></a> */}
                                            {ACCESS_TOKEN_NAME() ? (

                                                <div key={profileData.id}>
                                                    {followedBasedOnUserId.some(
                                                        (follow) => follow.institute_id === profileData.id
                                                    ) ? (
                                                        <button className="theme-btn connect me-2"
                                                            onClick={() => toggleFollow(profileData.id)}>UnConnectMe </button>
                                                    ) : (
                                                        <button
                                                            className="theme-btn connect me-2"
                                                            onClick={() => toggleFollow(profileData.id)}
                                                        > ConnectMe<i class="fa-light fa-handshake"></i></button>
                                                    )}
                                                </div>
                                            ) : (
                                                <span className="theme-btn connect me-2">{teacherFollower} Connection</span>
                                            )}

                                            <button onClick={() => window.open(shareLink, '_blank')}>
                                                <img src="https://img.icons8.com/color/48/000000/whatsapp.png" alt="WhatsApp"
                                                    style={{ width: '24px', marginRight: '10px' }} />
                                                Share to WhatsApp
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3 mt-3">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <textarea name="message" cols="30" rows="5" class="form-control" placeholder="Biography" defaultValue={bioInfo.bio_info} disabled></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="pd-sidebar-box-right">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h4 class="pd-user-banner-title">{profileData?.full_name}</h4>
                                        </div>
                                        <div class="col-md-6 d-flex justify-content-end">
                                            <div class="pd-user-banner-btn">
                                                <a href="#" class="theme-btn" onClick={(e) => {
                                                    e.preventDefault();
                                                    setShowFormModal1(true);
                                                }}><i class="far fa-phone-volume"></i> Call</a>
                                                <a href="#" class="theme-btn whatsapp" onClick={(e) => e.preventDefault()}><i class="fab fa-whatsapp"></i> Whatsapp</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row pt-2">
                                        <div class="col-md-8"><span class="location-area"><i class="fa-solid fa-location-dot"></i></span><span class="location-text">{profileData.location}</span></div>
                                        <div class="col-md-4 d-flex justify-content-end">
                                            <div class="pd-user-banner-btn">
                                                <a href="#" className="theme-btn" onClick={handleDownloadClick}>
                                                    Download Brochure <i className="fad fa-download"></i>
                                                </a>


                                                {/* <a href="#" class="theme-btn" onClick={(e) => { e.preventDefault(); setShowFormModal(true); }}> Download Brochure <i class="fad fa-download"></i></a> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div class="pt-5 result">
                                    <div class="slider_wrap pt-40 pb-50" style={curvebgStyle}>
                                        <div class="col-lg-12">
                                            <div class="row">
                                                <div class="col-md-5 layer_up">
                                                    <h4> <span class="years">10+ Years </span> of<br/>legacy with<br/>sterling Results</h4>
                                                </div>
                                                <div class="col-md-7">
                                                  
                                                    <SterLingResultSlider />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                    <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Download Brochure</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form onSubmit={handleFormSubmit}>
                                                <Form.Group>
                                                    <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange1}
                                                        required
                                                        placeholder="Enter your name"
                                                        style={{ borderColor: formData.name ? "#ccc" : "red" }}
                                                    />
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange1}
                                                        required
                                                        placeholder="Enter your email"
                                                        style={{ borderColor: formData.email ? "#ccc" : "red" }}
                                                    />
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Phone</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={handleChange1}
                                                        required
                                                        placeholder="Enter your phone number"
                                                        style={{ borderColor: formData.phone ? "#ccc" : "red" }}
                                                    />
                                                </Form.Group>
                                                <Button variant="primary" type="submit" className="mt-3">
                                                    Submit
                                                </Button>
                                            </Form>
                                        </Modal.Body>
                                    </Modal>

                                    {/* OTP Modal */}
                                    <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Enter OTP</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form onSubmit={handleOtpSubmit} style={{ textAlign: "center" }}>
                                                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                                                    Enter 6-digit OTP
                                                </Form.Label>
                                                <div style={{ display: "flex", justifyContent: "center", gap: "10px", margin: "10px 0" }}>
                                                    {otp.map((digit, index) => (
                                                        <input
                                                            key={index}
                                                            id={`otp-${index}`}
                                                            type="text"
                                                            value={digit}
                                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                                            maxLength="1"
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                textAlign: "center",
                                                                fontSize: "18px",
                                                                fontWeight: "bold",
                                                                border: "2px solid #007bff",
                                                                borderRadius: "5px",
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                                <Button variant="success" type="submit" className="mt-3">
                                                    Verify OTP
                                                </Button>
                                            </Form>
                                        </Modal.Body>
                                    </Modal>


                                    <Modal show={showFormModal1} onHide={() => setShowFormModal1(false)}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Enter mobile Number</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form onSubmit={handleFormSubmit1}>

                                                <Form.Group>
                                                    <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Phone</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="phone"
                                                        value={formData3.phone}
                                                        onChange={handleChange2}
                                                        required
                                                        placeholder="Enter your phone number"
                                                        style={{ borderColor: formData3.phone ? "#ccc" : "red" }}
                                                    />
                                                </Form.Group>
                                                <Button variant="primary" type="submit" className="mt-3">
                                                    Submit
                                                </Button>
                                            </Form>
                                        </Modal.Body>
                                    </Modal>

                                    {/* OTP Modal */}
                                    <Modal show={showOtpModal1} onHide={() => setShowOtpModal1(false)}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Enter OTP</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form onSubmit={handleOtpSubmit1} style={{ textAlign: "center" }}>
                                                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                                                    Enter 6-digit OTP
                                                </Form.Label>
                                                <div style={{ display: "flex", justifyContent: "center", gap: "10px", margin: "10px 0" }}>
                                                    {otp1.map((digit, index) => (
                                                        <input
                                                            key={index}
                                                            id={`otp-${index}`}
                                                            type="text"
                                                            value={digit}
                                                            onChange={(e) => handleOtpChange1(index, e.target.value)}
                                                            maxLength="1"
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                textAlign: "center",
                                                                fontSize: "18px",
                                                                fontWeight: "bold",
                                                                border: "2px solid #007bff",
                                                                borderRadius: "5px",
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                                <Button variant="success" type="submit" className="mt-3">
                                                    Verify OTP
                                                </Button>
                                            </Form>
                                        </Modal.Body>
                                    </Modal>

                                    {/* <div className="pt-5 result">
                                        <div className="slider_wrap pt-40 pb-50 position-relative">
                                            <div className="container">
                                                <div className="row align-items-center">
                                                   
                                                    <div class="col-md-5 layer_up">
                                                        <h4 className="text-overlay">
                                                            <span className="years">10+ Years</span> of<br />legacy with<br />sterling Results
                                                        </h4>
                                                    </div>

                                                   
                                                    <div className="col-md-12">
                                                        <SterLingResultSlider />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="pt-5 result">
                                        <div className="slider_wrap pt-40 pb-50 position-relative">
                                            <div className="container">
                                                <div className="row align-items-center">
                                                    {/* Text Section (Left Side) */}
                                                    <div className="col-md-5 col-12 layer_up">
                                                        <h4 className="text-overlay">
                                                            <span className="years">10+ Years</span> of<br />legacy with<br />sterling Results
                                                        </h4>
                                                    </div>

                                                    {/* Slider Section (Right Side) */}
                                                    <div className="col-md-7 col-12">
                                                        <SterLingResultSlider />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row pt-4">
                                        {posts.length > 0 ? (
                                            <>
                                                {posts.slice(0, 3).map((post, index) => (
                                                    <div className="col-md-3 col-6 ps-0" key={index}>
                                                        <div className="video_wraper">
                                                            <img src={`${Image_Base_Url}${post.post_image_path}`} alt="Post" />
                                                        </div>
                                                    </div>
                                                ))}

                                                {/* Show "30+ More" if there are more than 4 posts */}
                                                {posts.length > 4 && (
                                                    <div className="col-md-3 col-6 pe-0">
                                                        <div className="video_wraper last-thumb position-relative">
                                                            <img src={`${Image_Base_Url}${posts[3].post_image_path}`} alt="More Post" />
                                                            <div className="more_text">+ More</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div>No post available.</div>
                                        )}
                                    </div>
                                    <div class="row pt-4">
                                        <div class="doubt-solving bg2 py-4 px-4">
                                            {/* <p class="evolve text-center"><span class="org-clr">Lets Evolve the</span> <span>Paradigm of Education</span></p>
                                            <p class="doubt-title">24x7 Study-Doubt Solving</p> */}
                                            <p class="evolve text-center"><span class="org-clr">{letsParadigm?.data?.description}</span></p>

                                            {/* <div class="col-md-12 pt-4">
                                            <div class="form-group">
                                                <textarea name="message" cols="30" rows="5" class="form-control" placeholder="Biography"></textarea>
                                            </div>
                                        </div> */}
                                            {/* <div class="row  pt-3">
                                            <div class="col-md-10">
                                                <div class="schedule position-relative"><input type="text" class="form-control" /><input id="cv" type="file" hidden /><label class="hide" for="cv"><span>Choose File</span></label></div>
                                            </div>
                                            <div class="col-md-2 slv_btn btn_center">
                                                <button type="submit" class="theme-btn">Submit<i class="far fa-paper-plane"></i></button>
                                            </div>
                                        </div> */}
                                        </div>
                                    </div>
                                    <div class="meet_topers py-4">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center">
                                                    <h3 class="site-title">Meet Our Toppers</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <TopperSlider />
                                        {/* <div class="topper-slider owl-carousel owl-theme">
                                        <div class="text-center topr_ctr">
                                            <p class="topper_title">AIR 436</p>
                                            <p class="name_title">Nisha</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                        </div>
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb">
                                        </div>
                                        <div class="text-center topr_ctr">
                                            <p class="topper_title">AIR 736</p>
                                            <p class="name_title">Diya</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                        </div>
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb">
                                        </div>
                                        <div class="text-center topr_ctr">
                                            <p class="topper_title">AIR 736</p>
                                            <p class="name_title">Diya</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                        </div>
                                    </div> */}
                                    </div>
                                    <section class="sec_bg">
                                        <div class="container">
                                            <div class="row">
                                                <div class="add-dvd">
                                                    <span class="add-norm">Book your Admission at <br /> <span class="add-bld"><a href="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">discounted Price</a></span>
                                                    </span>
                                                    <span>
                                                        <button type="submit" class="theme-btn mt-30" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Click Here
                                                            <i class="fas fa-arrow-right-long"></i></button>
                                                        {/* <a href="#" class="theme-btn mt-30" onClick={(e) => e.preventDefault()}>Click Here<i class="fas fa-arrow-right-long"></i></a> */}
                                                    </span>
                                                    <span><img src={addGirl} /></span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    {/* <section class="py-4">
                                        <div class="site-heading text-center">
                                            <h3 class="site-title">Find a Center</h3>
                                        </div>
                                        <div class="find_center">
                                            <div class="form_row">
                                                <div class="label">
                                                    <label for="category" class="" title="Category">Category</label>
                                                </div>
                                                <div class="frm_inpt">
                                                    <select class="" aria-label="Default" disabled>
                                                        <option selected>Select Category</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form_row">
                                                <div class="label">
                                                    <label for="Board" class="" title="Category">Board</label>
                                                </div>
                                                <div class="frm_inpt">
                                                    <select class="" aria-label="Default" disabled>
                                                        <option selected>Select Board</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form_row">
                                                <div class="label">
                                                    <label for="Standards" class="" title="Standards">Standards</label>
                                                </div>
                                                <div class="frm_inpt">
                                                    <select class="" aria-label="Default" disabled>
                                                        <option selected>Select Standards</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form_row">
                                                <div class="label">
                                                    <label for="City" class="" title="City">City</label>
                                                </div>
                                                <div class="frm_inpt">
                                                    <select class="" aria-label="Default" disabled>
                                                        <option selected>Select City</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form_row">
                                                <div class="label">
                                                    <label for="cateAreagory" class="" title="Area">Area</label>
                                                </div>
                                                <div class="frm_inpt">
                                                    <select class="" aria-label="Default" disabled>
                                                        <option selected>Select Area</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 slv_btn btn_center">
                                                <button type="submit" class="theme-btn" onClick={(e) => e.preventDefault()}>Submit<i class="far fa-paper-plane"></i></button>
                                            </div>
                                        </div>
                                    </section> */}

                                    <section className="py-4">
                                        <div className="site-heading text-center">
                                            <h3 className="site-title">Find a Center</h3>
                                        </div>
                                        <div className="find_center">
                                            {/* Category */}
                                            <div className="form_row">
                                                <div className="label">
                                                    <label htmlFor="category" title="Category">Category</label>
                                                </div>
                                                <div className="frm_inpt">
                                                    <select
                                                        id="category"
                                                        className="form-select"
                                                        value={selectedCategory}
                                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                                    >
                                                        <option value="">Select Category</option>
                                                        {categories.map((cat) => (
                                                            <option key={cat.id} value={cat.categoty_name}>
                                                                {cat.categoty_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Board */}
                                            <div className="form_row">
                                                <div className="label">
                                                    <label htmlFor="board" title="Board">Board</label>
                                                </div>
                                                <div className="frm_inpt">
                                                    <select
                                                        id="board"
                                                        className="form-select"
                                                        value={selectedBoard}
                                                        onChange={(e) => setSelectedBoard(e.target.value)}
                                                    >
                                                        <option value="">Select Board</option>
                                                        {boards.map((b) => (
                                                            <option key={b.id} value={b.board_name}>
                                                                {b.board_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Standards */}
                                            <div className="form_row">
                                                <div className="label">
                                                    <label htmlFor="standards" title="Standards">Standards</label>
                                                </div>
                                                <div className="frm_inpt">
                                                    <select
                                                        id="standards"
                                                        className="form-select"
                                                        value={selectedStandard}
                                                        onChange={(e) => setSelectedStandard(e.target.value)}
                                                    >
                                                        <option value="">Select Standards</option>
                                                        {standards.map((s) => (
                                                            <option key={s.id} value={s.standards_name}>
                                                                {s.standards_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* City */}
                                            <div className="form_row">
                                                <div className="label">
                                                    <label htmlFor="city" title="City">City</label>
                                                </div>
                                                <div className="frm_inpt">
                                                    <select
                                                        id="city"
                                                        className="form-select"
                                                        value={selectedCity}
                                                        onChange={(e) => setSelectedCity(e.target.value)}
                                                    >
                                                        <option value="">Select City</option>
                                                        {cities.map((c) => (
                                                            <option key={c.id} value={c.city_name}>
                                                                {c.city_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Area */}
                                            <div className="form_row">
                                                <div className="label">
                                                    <label htmlFor="area" title="Area">Area</label>
                                                </div>
                                                <div className="frm_inpt">
                                                    <select
                                                        id="area"
                                                        className="form-select"
                                                        value={selectedArea}
                                                        onChange={(e) => setSelectedArea(e.target.value)}
                                                    >
                                                        <option value="">Select Area</option>
                                                        {areas.map((a) => (
                                                            <option key={a.id} value={a.area_name}>
                                                                {a.area_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Submit Button */}
                                            <div className="col-md-2 slv_btn btn_center mt-3">
                                                <button
                                                    type="submit"
                                                    className="theme-btn"
                                                    onClick={saveFinderData}
                                                >
                                                    Submit <i className="far fa-paper-plane"></i>
                                                </button>
                                            </div>

                                            {/* Saved Data List */}
                                            {/* {finderList.length > 0 && (
                                                <div className="mt-5">
                                                    <h5>Saved Center Data</h5>
                                                    <ul className="list-group">
                                                        {finderList.map((item, index) => (
                                                            <li key={index} className="list-group-item">
                                                                <strong>Category:</strong> {item.category_name} |{' '}
                                                                <strong>Board:</strong> {item.board_name} |{' '}
                                                                <strong>Standard:</strong> {item.standard_name} |{' '}
                                                                <strong>City:</strong> {item.city_name} |{' '}
                                                                <strong>Area:</strong> {item.area_name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )} */}
                                        </div>
                                    </section>


                                  
                                    <CenterList data={results}/>

                                    {/* <div class="add-banner py-4">
                                        <img src={addBanner} />
                                    </div> */}
                                    <div className="add-banner py-4">
                                        <a href="https://exam.padhaidekho.com/register" target="_blank" rel="noopener noreferrer">
                                            <img src={addBanner} alt="Banner" style={{ cursor: "pointer" }} />
                                        </a>
                                    </div>
                                    <div class="video explore_course exams course-area universities">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center">
                                                    <h3 class="site-title">Watch Our Video</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <VideoSlider />
                                    </div>
                                    <div class="meet_team">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center">
                                                    <h3 class="site-title">Meet Our Expert Team</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <ExpertSlider />
                                        {/* <div class="meet-slider owl-carousel owl-theme">
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb" />
                                            <p class="meet_title">Pooja Singh</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                            <p class="name_title">Sr. Mentor</p>
                                        </div>
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb" />
                                            <p class="meet_title">Aditi Singh</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                            <p class="name_title">Sr. Mentor</p>
                                        </div>
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb" />
                                            <p class="meet_title">Aditi Singh</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                            <p class="name_title">Sr. Mentor</p>
                                        </div>
                                        <div class="text-center">
                                            <img src="assets/img/course/slider-thumb1.png" alt="thumb" />
                                            <p class="meet_title">Aditi Singh</p>
                                            <p class="course_title">JEE MAIN 2022</p>
                                            <p class="name_title">Sr. Mentor</p>
                                        </div>
                                    </div> */}
                                        {/* <p>NOT AVAILABLE</p> */}
                                    </div>
                                    <div class="pd_branches py-4">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center">
                                                    <h3 class="site-title">Our Branches</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <BranchSlider />
                                    </div>
                                    {/* <section class="Any-Doubts">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center">
                                                    <h3 class="site-title">Have Any Doubts? Let’s Connect</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doubt-solving bg2 py-4 px-4">
                                            <div class="row">
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="Name" class="" title="Name">Name</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <input type="text" id="name" placeholder="Name" required="" aria-required="true" value="" />
                                                    </div>
                                                </div>
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="Name" class="" title="Name">Mobile</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <input type="text" id="mobile" placeholder="Enter Mobile" required="" aria-required="true" value="" />
                                                    </div>
                                                </div>
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="Name" class="" title="Name">Email</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <input type="email" id="email" placeholder="Email ID" required="" aria-required="true" value="" />
                                                    </div>
                                                </div>
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="category" class="" title="Category">Category</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <select class="" aria-label="Default">
                                                            <option selected="">Select Category</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="Board" class="" title="Category">Board</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <select class="" aria-label="Default">
                                                            <option selected="">Select Board</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="form_row col-md-4">
                                                    <div class="label">
                                                        <label for="Standards" class="" title="Standards">Standards</label>
                                                    </div>
                                                    <div class="frm_inpt">
                                                        <select class="" aria-label="Default">
                                                            <option selected="">Select Standards</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="slv_btn btn_center pt-3 justify-content-center">
                                                    <button type="submit" class="theme-btn">Submit<i class="far fa-paper-plane"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </section> */}

                                    <section className="Any-Doubts">
                                        <div className="row">
                                            <div className="col-lg-12 text-center">
                                                <div className="site-heading text-center">
                                                    <h3 className="site-title">Have Any Doubts? Let’s Connect</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="doubt-solving bg2 py-4 px-4">
                                            <form onSubmit={submitDoubtForm}>
                                                <div className="row">
                                                    {/* Name Input */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="name">Name</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <input type="text" id="name" name="name" placeholder="Name" required value={doubtData.name} onChange={updateDoubtData} />
                                                        </div>
                                                    </div>

                                                    {/* Mobile Input */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="phone">Mobile</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <input type="text" id="phone" name="phone" placeholder="Enter Mobile" required value={doubtData.phone} onChange={updateDoubtData} />
                                                        </div>
                                                    </div>

                                                    {/* Email Input */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="email">Email</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <input type="email" id="email" name="email" placeholder="Email ID" required value={doubtData.email} onChange={updateDoubtData} />
                                                        </div>
                                                    </div>

                                                    {/* Category Select */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="category">Category</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <select id="category" name="category" required value={doubtData.category} onChange={updateDoubtData}>
                                                                <option value="">Select Category</option>
                                                                <option value="Math">Math</option>
                                                                <option value="Science">Science</option>
                                                                <option value="English">English</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Board Select */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="board">Board</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <select id="board" name="board" required value={doubtData.board} onChange={updateDoubtData}>
                                                                <option value="">Select Board</option>
                                                                <option value="CBSE">CBSE</option>
                                                                <option value="ICSE">ICSE</option>
                                                                <option value="mp">MP Board</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Standards Select */}
                                                    <div className="form_row col-md-4">
                                                        <div className="label">
                                                            <label htmlFor="standards">Standards</label>
                                                        </div>
                                                        <div className="frm_inpt">
                                                            <select id="standards" name="standards" required value={doubtData.standards} onChange={updateDoubtData}>
                                                                <option value="">Select Standards</option>
                                                                <option value="Class 10">Class 10</option>
                                                                <option value="Class 12">Class 12</option>
                                                                <option value="Graduate">Graduate</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Submit Button */}
                                                    <div className="slv_btn btn_center pt-3 justify-content-center">
                                                        <button type="submit" className="theme-btn">
                                                            Submit <i className="far fa-paper-plane"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </section>
                                    <section class="rating pt-4">
                                        <div class="row">
                                            <div class="col-lg-12 text-center">
                                                <div class="site-heading text-center mb-3">
                                                    <h3 class="site-title">How Would You Rate This Page</h3>
                                                </div>
                                                <p><em>We will use this feedback to improve your experience</em></p>
                                                <div class="pd_10 pb-0 video_title">
                                                    {/* <div class="course-rating">
                                                        <i class="fas fa-star"></i>
                                                        <i class="fas fa-star"></i>
                                                        <i class="fas fa-star"></i>
                                                        <i class="fas fa-star"></i>
                                                        <i class="far fa-star"></i>
                                                    </div> */}
                                                    <div class="pd-instructor-rating">
                                                        {renderStars(averageRatings)}
                                                    </div>
                                                    <span>{String(averageRatings)}</span>
                                                    <span> Ratings </span>
                                                </div>
                                                <h5 class="pt-3"><em>Rate Us Now</em></h5>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        {/* <div class="row contact-form">
                            <form className="row subscription-form" onSubmit={handleSubmit}>
                                <div class="col-lg-9">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="name" value={formData.name} onChange={handlesubsChange} placeholder="Your Name" required="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input type="phone" class="form-control" name="phone" value={formData.phone} onChange={handlesubsChange} placeholder="Your Contact Number" required="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input type="email" class="form-control" name="email" value={formData.email} onChange={handlesubsChange} placeholder="Your Email" required="" />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <textarea name="message" cols="30" rows="5" class="form-control" placeholder="Write Your Message"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 d-flex align-items-center"><button type="submit" class="theme-btn">Send Message <i class="far fa-paper-plane"></i></button></div>
                            </form>
                        </div> */}
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default TeacherDetail;
